define.alias("shared/components/shared/ui/switcher", "calendar/components/shared/ui/switcher");